import Head from 'next/head';
import Image from 'next/image';

import fs from 'fs';
import path from 'path';
import matter from 'gray-matter';
import { remark } from 'remark';
import html from 'remark-html';
import { format } from 'date-fns';

export async function getStaticPaths() {
  const files = fs.readdirSync('posts');
  const paths = files.map((filename) => ({
    params: { id: filename.replace('.md', '') },
  }));
  return { paths, fallback: false };
}

export async function getStaticProps({ params }) {
  const filePath = path.join('posts', `${params.id}.md`);
  const fileContents = fs.readFileSync(filePath, 'utf-8');
  const { data, content } = matter(fileContents);
  const processedContent = await remark().use(html).process(content);

  return {
    props: {
      postData: {
        ...data,
        contentHtml: processedContent.toString(),
        id: params.id,
      },
    },
  };
}

export default function Post({ postData }) {
  return (
    <div className="max-w-3xl mx-auto p-4">
      {/* 🔻 SEO Integration */}
      <Head>
        <title>{postData.title}</title>
        <meta name="description" content={postData.excerpt || postData.title} />
      </Head>

{/* ✅ Banner image using next/image 
      {postData.bannerImage && (
        <div className="mb-6">
          <Image
            src={postData.bannerImage}
            alt={postData.title}
            width={1200}
            height={600}
            className="rounded-xl shadow-lg object-cover"
          />
        </div>
      )}
*/}

      <h1 className="text-3xl font-bold">{postData.title}</h1>
      <p className="text-gray-500 mb-4">
        {format(new Date(postData.date), 'MMMM d, yyyy')}
      </p>
      <div
        dangerouslySetInnerHTML={{ __html: postData.contentHtml }}
        className="prose"
      />
    </div>
  );
}
